module.exports = __webpack_public_path__ + "static/media/TopBackground2.2036b7c9.JPG";